var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.12499 30.29112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: none;\r\n      }\r\n\r\n      .b {\r\n        clip-path: url(#a);\r\n      }\r\n\r\n      .c {\r\n        fill: #84c665;\r\n      }\r\n\r\n      .d {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-667.99787 -654.71854)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 560.21047,
    y: 497.52233,
    width: 178.58289,
    height: 263.62201
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M667.99787,683.88453a57.49241,57.49241,0,0,1,8.646.213c3.533.338,3.826.922,9.772.912a11.36619,11.36619,0,0,0,4.188-1.054l52.519-21.598-3.086-7.639Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M688.36914,676.33984l1.05664,2.61328,3.02149-1.2207-1.05665-2.61328.81446-.3291,2.52344,6.24609-.81446.3291-1.18359-2.92871-3.02149,1.22071,1.1836,2.92871-.80469.32519L687.5625,676.666Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M698.18359,676.23438l-2.42968.98046.91015,2.252,2.707-1.09278.27344.67578-3.51172,1.41895-2.52539-6.24512,3.373-1.36328.27344.67676-2.56641,1.03711.79688,1.97363,2.42773-.98047Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M698.14258,672.3916l.80664-.32617,2.25,5.56934,2.668-1.07813.27343.67578-3.4746,1.4043Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M702.54883,670.69727a10.18859,10.18859,0,0,1,1.49805-.7461,2.77757,2.77757,0,0,1,1.96093-.18847,1.81436,1.81436,0,0,1,1.07617,1.08593,1.99332,1.99332,0,0,1,.05664,1.5293,2.79417,2.79417,0,0,1-1.63281,1.457,3.06654,3.06654,0,0,1-.66992.207l1.00977,2.501-.80469.32617Zm2.02344,2.68652a2.9858,2.9858,0,0,0,.69335-.20508c.97266-.39355,1.375-1.10547,1.0254-1.9668-.332-.82519-1.07813-.9873-1.9668-.62793a3.63912,3.63912,0,0,0-.73438.37207Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M707.42383,668.6416l3.36328-1.35937.27344.67675-2.5586,1.03321.83985,2.07617,2.36328-.95508.26953.668-2.36328.95508,1.14258,2.82519-.80664.3252Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M712.74414,666.49121l1.49414,3.69824c.56641,1.39844,1.42774,1.74121,2.26172,1.4043.92578-.374,1.27148-1.22656.71289-2.60645L715.71875,665.29l.81641-.33008,1.4707,3.6416c.77539,1.91895.084,3.11426-1.26953,3.66114-1.27735.5166-2.53711.17382-3.32031-1.76368l-1.48633-3.67871Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M717.91016,664.40527l.80468-.32617,2.25,5.56934,2.66993-1.07813.27343.67578-3.47461,1.4043Z",
    transform: "translate(-667.99787 -654.71854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpful);
export default __webpack_public_path__ + "static/media/Helpful.68ca8925eca8ef5bf15096989ed6a377.svg";
export { ForwardRef as ReactComponent };